import CustomFont from './CustomFont'

export default (...props) => {
    return CustomFont('BarlowLight', ...props)
}
  